var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './FileCard.module.scss';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import { Icons } from 'src/ui/components/Icons/Icons';
export var FileCard = function (props) {
    var name = props.name, size = props.size, type = props.type, onRemoveFile = props.onRemoveFile;
    var handleRemoveFile = function (e) {
        e.stopPropagation();
        onRemoveFile();
    };
    var iconByType = function () {
        switch (type) {
            case 'text/csv':
            case 'application/vnd.ms-excel':
                return E_ICONS.CSV;
            case 'application/pdf':
                return E_ICONS.PDF;
            default:
                return E_ICONS.PICTURE;
        }
    };
    var calculateWithPrecisionSize = function () {
        var sizeInKo = size / 1000;
        var sizeInMo = sizeInKo / 1000;
        var sizeInGo = sizeInMo / 1000;
        if (sizeInGo > 1) {
            return "".concat(sizeInGo.toFixed(2), " Go");
        }
        if (sizeInMo > 1) {
            return "".concat(sizeInMo.toFixed(2), " Mo");
        }
        if (sizeInKo > 1) {
            return "".concat(sizeInKo.toFixed(2), " Ko");
        }
        return "".concat(size, " octets");
    };
    var icon = iconByType();
    var sizeCalculated = calculateWithPrecisionSize();
    return (_jsxs("div", __assign({ className: styles.FileCardWrapper }, { children: [_jsxs("div", __assign({ className: styles.FileCardInfoContent }, { children: [_jsx(Icons, { icon: icon, className: styles.fileCardFileIcon }), _jsxs("div", __assign({ className: styles.FileCardInfoWrapper }, { children: [_jsx("span", __assign({ className: styles.FileCardInfoName }, { children: name })), _jsx("span", __assign({ className: styles.FileCardInfoSize }, { children: sizeCalculated }))] }))] })), _jsx(Icons, { icon: E_ICONS.TRASH, className: styles.FileCardDeleteIcon, onClick: handleRemoveFile })] })));
};
